var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataType == 'html')?_c('span',{domProps:{"innerHTML":_vm._s(_vm.displayValue)}}):_c('span',{staticClass:"ds-span"},[_vm._v(_vm._s(_vm.displayValue))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8214ea5c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/k-element/k-field-display/k-field-display.vue
// module id = null
// module chunks = 